// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "banner-image-module--base-text-alt--global--fa86a";
export var baseTextGlobal = "banner-image-module--base-text--global--787f7";
export var blockSpacing100 = "banner-image-module--block-spacing-100--47ac5";
export var blockSpacing50 = "banner-image-module--block-spacing-50--943a9";
export var blockVPadding100 = "banner-image-module--block-v-padding-100--3b0fe";
export var blockVPadding50 = "banner-image-module--block-v-padding-50--45333";
export var captionTextGlobal = "banner-image-module--caption-text--global--da1d8";
export var cmsRenderedContentGlobal = "banner-image-module--cms-rendered-content--global--0c2d3";
export var colorFill = "banner-image-module--colorFill--1f92f";
export var container = "banner-image-module--container--c5f5b";
export var defaultHSpacingGlobal = "banner-image-module--default-h-spacing--global--97fa8";
export var fadeInAnimation = "banner-image-module--fadeInAnimation--02d2b";
export var fadeInOnLoadGlobal = "banner-image-module--fade-in-on-load--global--25c6b";
export var fullHeightGlobal = "banner-image-module--full-height--global--33b27";
export var fullHeightOmittingNavGlobal = "banner-image-module--full-height-omitting-nav--global--7741c";
export var halfHeight = "banner-image-module--halfHeight--40b30";
export var headingTextGlobal = "banner-image-module--heading-text--global--87968";
export var image = "banner-image-module--image--661dc";
export var imageContainer = "banner-image-module--imageContainer--b3b95";
export var imageLeft = "banner-image-module--imageLeft--593ce";
export var imageRight = "banner-image-module--imageRight--3235a";
export var imgContainer = "banner-image-module--imgContainer--f3aa8";
export var ingressTextGlobal = "banner-image-module--ingress-text--global--6a5f1";
export var linkColorChangeTransitionGlobal = "banner-image-module--link-color-change-transition--global--ee331";
export var mobileNavBarHeight = "85px";
export var omitNavbarHeight = "banner-image-module--omitNavbarHeight--0b0d6";
export var pageHeadingTextGlobal = "banner-image-module--page-heading-text--global--8f9cf";
export var paragraphTextGlobal = "banner-image-module--paragraph-text--global--a1a1c";
export var subheadingTextGlobal = "banner-image-module--subheading-text--global--58186";
export var wrap = "banner-image-module--wrap--7c210";
export var wrapped = "banner-image-module--wrapped--1ef05";